// removed by extract-text-webpack-plugin
module.exports = {"block":"_2XkMiMycnGnKN6hCEAvbDW","caption":"VIVZLLEqmOqzQmWqwL_pn","carousel":"_27veRyUj9h1ZJ_L-tJey2A","dummy":"_1nHquYqYbsdBzmtGlo5Ban"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ImageBlock/ImageBlock.module.scss
// module id = 777
// module chunks = 0